import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import DeleteAllowListFormModal from 'src/features/allowList/components/forms/DeleteAllowListFormModal';
import UpdateAllowListFormModal from 'src/features/allowList/components/forms/UpdateAllowListFormModal';
import { allowListMessages } from 'src/features/allowList/utils/allowListMessages';
import { AllowList } from 'src/features/allowList/utils/types';
import { PERMISSION } from 'src/features/auth/types';
import { PATH } from 'src/features/navigation/utils/constants';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellWhiteListActions({ row }: CellContext<AllowList, unknown>) {
    const { formatMessage } = useIntl();
    const manageAllowLists = useHasPermissions([PERMISSION.MANAGE_ALLOW_LISTS]);

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                {manageAllowLists && (
                    <>
                        <Tooltip>
                            <UpdateAllowListFormModal
                                selectedAllowList={row.original}
                                semantics={{ entryName: formatMessage(allowListMessages.whiteList).toLowerCase() }}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdateAllowListFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        <Tooltip>
                            <DeleteAllowListFormModal
                                selectedAllowList={row.original}
                                semantics={{ entryName: formatMessage(allowListMessages.whiteList).toLowerCase() }}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                    </Button>
                                </TooltipTrigger>
                            </DeleteAllowListFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.delete} />
                            </TooltipContent>
                        </Tooltip>
                    </>
                )}
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/${PATH.ADMINISTRATION}/white-list/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
